import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    const { error } = await signIn(email, password);
    setBusy(false);
    if (error) setErr(error);
    else navigate('/companies');
  }

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src="/logo.svg" alt="DodoBooks" width={42} height={42} className="rounded-lg" />
          <div className="text-center">
            <div className="font-serif text-2xl font-bold leading-none">DodoBooks</div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-text-mute mt-1">by CloudDodo</div>
          </div>
        </div>

        <div className="card">
          <h1 className="h-section mb-1">Welcome back</h1>
          <p className="text-sm text-text-dim mb-6">Sign in to your books.</p>

          <form onSubmit={onSubmit} className="flex flex-col gap-4">
            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@business.co.za"
              />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>

            {err && (
              <div className="text-sm text-rust bg-rust/10 border border-rust/30 px-3 py-2 rounded-md">
                {err}
              </div>
            )}

            <button type="submit" disabled={busy} className="btn btn-primary disabled:opacity-50">
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div className="mt-6 text-sm text-text-dim text-center">
            Need an account?{' '}
            <a href="https://wa.me/27636928368?text=Hi%20CloudDodo%2C%20I%27d%20like%20a%20DodoBooks%20account" className="text-emerald hover:underline">
              Talk to us
            </a>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-text-mute">
          <a href="/" className="hover:text-text">← Back to marketing site</a>
        </div>
      </div>
    </div>
  );
}
